module.exports = __webpack_public_path__ + "img/raffle.b377473a.png";